import React from "react";
import img1 from "../images/image-product-1-thumbnail.jpg";
import CartContext from "../context/CartContext";
import { useContext } from "react";

export default function CartItems(props) {
  const { setCart } = useContext(CartContext);
  return (
    <div className="cart-items">
      <img src={img1} alt="Product" width="50rem" />
      <div className="cart-item-details">
        <span className="productTitle">Autumn Limited Edition...</span>
        <span className="item-quantity">$125.00 x {props.quantity}</span>
        <b>${125 * props.quantity}.00</b>
      </div>
      <svg
        style={{ cursor: "pointer" }}
        onClick={() => setCart({ itemQty: 0, items: "" })}
        width="14"
        height="16"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path
            d="M0 2.625V1.75C0 1.334.334 1 .75 1h3.5l.294-.584A.741.741 0 0 1 5.213 0h3.571a.75.75 0 0 1 .672.416L9.75 1h3.5c.416 0 .75.334.75.75v.875a.376.376 0 0 1-.375.375H.375A.376.376 0 0 1 0 2.625Zm13 1.75V14.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 14.5V4.375C1 4.169 1.169 4 1.375 4h11.25c.206 0 .375.169.375.375ZM4.5 6.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Zm3 0c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Zm3 0c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Z"
            id="a"
          />
        </defs>
        <use fill="currentColor" fillRule="nonzero" xlinkHref="#a" />
      </svg>
    </div>
  );
}
